import React from 'react';
import GalleryCard from '../components/GalleryCard';

function Gallery() {
    const blogPosts = [
        {
          title: 'NSS SPECIAL CAMP 2024',
          i1: "https://i.postimg.cc/L5cRNRYj/20240119-105333-AMBy-GPSMap-Camera.jpg",
          i2: "https://i.postimg.cc/d1DYFDG8/Copy-of-IMG-20240120-014651445-HDR-AE.jpg",
          i3: "https://i.postimg.cc/W1Mrm1F6/DSC05491.jpg",
          i4: "https://i.postimg.cc/mrHnyM3p/DSC05722.jpg",
          i5: "https://i.postimg.cc/3NcjqfYX/DSC05865.jpg",
          i6: "https://i.postimg.cc/yN2J3JsT/DSC06165.jpg",
          i7: "https://i.postimg.cc/NjT8NxVX/DSC06215.jpg",
          i8: "https://i.postimg.cc/PrdCDns0/DSC06401.jpg",
          i9: "https://i.postimg.cc/2jhWvxqL/DSC06769.jpg",
          i10: "https://i.postimg.cc/XN8wmJQ2/DSC06941.jpg",
          i11: "https://i.postimg.cc/xdLkHf8D/IMG-20240115-171446299-HDR-AE.jpg",
          i12: "https://i.postimg.cc/nLfrnykd/IMG-20240118-164322.jpg",
          i13: "https://i.postimg.cc/YSN90dDt/IMG-20240119-112303586-HDR-AE.jpg",
          i14: "https://i.postimg.cc/DZg8jx1x/IMG-20240121-071904897-HDR-AE.jpg",
          i15: "https://i.postimg.cc/023rBMJ1/IMG-20240121-093611-Burst05.jpg",
          i16: "https://i.postimg.cc/3JZnjhyG/IMG-5363.jpg",
          i17: "https://i.postimg.cc/6QXgWcGV/IMG-5774.jpg",
          i18: "https://i.postimg.cc/8z1Xxc8w/IMG-5832.jpg",
           
        },
        {
          title: 'BLOOD DONATION DRIVE',
          i1: "https://i.postimg.cc/QtTmzpFw/1.jpg",
          i2: "https://i.postimg.cc/YCDxqXgT/2.jpg",
          i3: "https://i.postimg.cc/cJVMfrFm/3.jpg",
          i4: "https://i.postimg.cc/kGNcJqFy/4.jpg",
          i5: "https://i.postimg.cc/zGGjNmLn/5.jpg",
          i6: "https://i.postimg.cc/RV9dPJ4p/6.jpg",
          i7: "https://i.postimg.cc/8PHHxkCp/7.jpg", 
        },
        {
            title: 'WINTER-DIWALI DONATION DRIVE',
            i1: "https://i.postimg.cc/vmDPd4q7/11.jpg",
            i2: "https://i.postimg.cc/Jhgp7Rvf/12.jpg",
            i3: "https://i.postimg.cc/zBbPTyTD/3.jpg",
            i4: "https://i.postimg.cc/QxkYgGK7/4.jpg",
            i5: "https://i.postimg.cc/cLx9X9fb/7.jpg",
            i6: "https://i.postimg.cc/zDhcBRJ0/wt1.jpg",
            i7: "https://i.postimg.cc/Y95DRtx6/wt2.jpg",
            i8: "https://i.postimg.cc/DyKYby0F/wt3.jpg",  
          },
          {
            title: 'TREE PLANTATION ACTIVITY',
            i1: "https://i.postimg.cc/4dBQ0sZ7/tp1.jpg",
            i2: "https://i.postimg.cc/2684hMvz/tp2.jpg",
            i3: "https://i.postimg.cc/65DLgHs0/tp3.jpg",
            i4: "https://i.postimg.cc/6Qhr7t8j/tp4.jpg",
            i5: "https://i.postimg.cc/T2NcqdCB/tp5.jpg",
            i6: "https://i.postimg.cc/SRnCt9D3/tp6.jpg",
            i7: "https://i.postimg.cc/Y0PfpRvt/tp7.jpg", 
          },
          {
            title: 'GANESH IDOL MAKING WORKSHOP',
            i1: "https://i.postimg.cc/zX2FjtBp/1.jpg",
            i2: "https://i.postimg.cc/j5hzJvmH/2.jpg",
            i3: "https://i.postimg.cc/y6vm1QFB/3.jpg",
            i4: "https://i.postimg.cc/brCkmrzd/4.jpg",
            i5: "https://i.postimg.cc/5yN85LWZ/5.jpg",
            i6: "https://i.postimg.cc/K8gB5mCv/6.jpg",
            i7: "https://i.postimg.cc/28tnv1cK/7.jpg", 
          },
          {
            title: 'SCHOOL TEACHING ACTIVITY',
            i1: "https://i.postimg.cc/6qfGyhjk/st1.jpg",
            i2: "https://i.postimg.cc/dtQh5rS0/st10.jpg",
            i3: "https://i.postimg.cc/0QpzBfsz/st2.jpg",
            i4: "https://i.postimg.cc/dVLLYvFP/st3.jpg",
            i5: "https://i.postimg.cc/L8bgY5D8/st4.jpg",
            i6: "https://i.postimg.cc/FRtfp62t/st5.jpg",
            i7: "https://i.postimg.cc/pd5hDvcY/st6.jpg",
            i8: "https://i.postimg.cc/MpTjpVyL/st7.jpg",
            i9: "https://i.postimg.cc/7hw582Hm/st8.jpg",
            i10: "https://i.postimg.cc/NfN5SFWk/st9.jpg", 
          },
          {
            title: 'FOOD DONATION DRIVE',
            i1: "https://i.postimg.cc/66k9vwVh/fd1.jpg",
            i2: "https://i.postimg.cc/021sNnxW/fd2.jpg",
            i3: "https://i.postimg.cc/pXQt5jL2/fd3.jpg",
            i4: "https://i.postimg.cc/GpgRh1hG/fd5.jpg",
            i5: "https://i.postimg.cc/TP18sHqw/fd6.jpg",
            i6: "https://i.postimg.cc/WzMxrRj9/fd7.jpg",
            i7: "https://i.postimg.cc/d0fMcm49/fd8.jpg", 
          },
          {
            title: 'CLEANLINESS DRIVE',
            i1: "https://i.postimg.cc/cLds4hZ7/pp1.jpg",
            i2: "https://i.postimg.cc/J45LgXJs/pp2.jpg",
            i3: "https://i.postimg.cc/ZKSmVH9k/pp3.jpg",
            i4: "https://i.postimg.cc/kM89QzgF/pp4.jpg",
            i5: "https://i.postimg.cc/B6P3wwc3/pp5.jpg",
            i6: "https://i.postimg.cc/6QmwcNZz/pp6.jpg",
            i7: "https://i.postimg.cc/NF1cQ9zP/pp7.jpg", 
          },
          {
            title: 'DATRI EVENT',
            i1: "https://i.postimg.cc/BbMXJVyz/1.jpg",
            i2: "https://i.postimg.cc/PxMqM7tq/2.jpg",
            i3: "https://i.postimg.cc/mk2gpSDy/3.jpg",
            i4: "https://i.postimg.cc/hGWPRnvj/4.jpg",
            i5: "https://i.postimg.cc/L65szvGH/5.jpg",
            i6: "https://i.postimg.cc/D0jy9b4k/6.jpg",
            i7: "https://i.postimg.cc/KvpRVCtk/7.jpg",  
          },
          {
            title: 'UNITY DAY RALLY',
            i1: "https://i.postimg.cc/K80LFQww/1.jpg",
            i2: "https://i.postimg.cc/gc3ZrG1v/2.jpg",
            i3: "https://i.postimg.cc/8PHfBtpc/3.jpg",
            i4: "https://i.postimg.cc/GpNyTtcj/4.jpg",
            i5: "https://i.postimg.cc/FRLJyvzX/5.jpg",
            i6: "https://i.postimg.cc/XqKGPg92/6.jpg",
            i7: "https://i.postimg.cc/Y0BL8PLG/7.jpg",
            i8: "https://i.postimg.cc/bwwD6krT/8.jpg",
          },
          {
            title: 'TREE CONSERVATION ACTIVITY',
            i1: "https://i.postimg.cc/brYTw4Cc/1.jpg",
            i2: "https://i.postimg.cc/yYdj4430/2.jpg",
            i3: "https://i.postimg.cc/tRrdzSvJ/3.jpg",
            i4: "https://i.postimg.cc/Yqh6D6T3/4.jpg",
            i5: "https://i.postimg.cc/L6wzcqpM/5.jpg",
            i6: "https://i.postimg.cc/d1sd2r8G/6.jpg",
            i7: "https://i.postimg.cc/G3zK5htc/7.jpg", 
          },
          {
            title: 'ARMY FESTIVAL',
            i1: "https://i.postimg.cc/tgJcCZcC/af1.jpg",
            i2: "https://i.postimg.cc/rskgWKf4/af2.jpg",
            i3: "https://i.postimg.cc/KcBHzy0L/af3.jpg",
            i4: "https://i.postimg.cc/Y26d7zSz/af4.jpg",
            i5: "https://i.postimg.cc/Wzw87TyH/af5.jpg",
            i6: "https://i.postimg.cc/kX7fgR63/af7.jpg",
            i7: "https://i.postimg.cc/Jz6Tg7hw/af8.jpg",  
          },
          {
            title: 'BHUMI DRIVE(RTE ACT)',
            i1: "https://i.postimg.cc/RFsprMdJ/1.jpg",
            i2: "https://i.postimg.cc/RZ5sxp7d/2.jpg",
            i3: "https://i.postimg.cc/c1zkXL6V/3.jpg",
            i4: "https://i.postimg.cc/8PrK3g6s/4.jpg",
            i5: "https://i.postimg.cc/FHyPrbG4/5.jpg",
            i6: "https://i.postimg.cc/Lsmxnq0Z/6.jpg",
            i7: "https://i.postimg.cc/Hxx39qmY/7.jpg", 
          },
          {
            title: 'Cosmos Eradication Drive',
            i1: "https://i.postimg.cc/kMh15gmT/1.jpg",
            i2: "https://i.postimg.cc/T1ZJJh2G/2.jpg",
            i3: "https://i.postimg.cc/26ydpnVr/3.jpg",
            i4: "https://i.postimg.cc/jjZ6kMqM/4.jpg",
            i5: "https://i.postimg.cc/63PrBTvR/5.jpg",
            i6: "https://i.postimg.cc/9QPYyW65/6.jpg",
            i7: "https://i.postimg.cc/MZ45S374/7.jpg",  
          },
          {
            title: 'RAKSHABANDHAN',
            i1: "https://i.postimg.cc/0Ny6BxBw/ra1.jpg",
            i2: "https://i.postimg.cc/JzP0Jvz4/ra2.jpg",
            i3: "https://i.postimg.cc/d3rDy0Lz/ra3.jpg",
            i4: "https://i.postimg.cc/MZQn49dd/ra4.jpg",
            i5: "https://i.postimg.cc/mrkDSjP3/ra5.jpg",
            i6: "https://i.postimg.cc/PqVLGcgF/ra6.jpg",
            i7: "https://i.postimg.cc/W3QhzZbG/ra7.jpg",  
          },
          {
            title: 'SAWALI NGO VISIT',
            i1: "https://i.postimg.cc/mZtqC5TZ/1.jpg",
            i2: "https://i.postimg.cc/Jhp6BbgB/2.jpg",
            i3: "https://i.postimg.cc/XYcDnMkL/3.jpg",
            i4: "https://i.postimg.cc/yYRbr3Jw/4.jpg",
            i5: "https://i.postimg.cc/bYW5T9vx/5.jpg",
            i6: "https://i.postimg.cc/xdfpCss2/6.jpg",
            i7: "https://i.postimg.cc/K8yHXcB4/7.jpg",
          },
          // {
          //   title: 'SOFT SKILLS ACTIVITY',
          //   i1: "https://i.postimg.cc/tgJcCZcC/af1.jpg",  
          //   i2: "https://i.postimg.cc/rskgWKf4/af2.jpg",  
          //   i3: "https://i.postimg.cc/KcBHzy0L/af3.jpg",  
          //   i4: "https://i.postimg.cc/Y26d7zSz/af4.jpg",  
          //   i5: "https://i.postimg.cc/Wzw87TyH/af5.jpg",  
          //   i6: "https://i.postimg.cc/kX7fgR63/af7.jpg",  
          //   i7: "https://i.postimg.cc/Jz6Tg7hw/af8.jpg ", 
          // },
          // {
          //   title: 'SECRETS TO A BALANCED LIFE SESSION',
          //   i1: "https://i.postimg.cc/tgJcCZcC/af1.jpg",  
          //   i2: "https://i.postimg.cc/rskgWKf4/af2.jpg",  
          //   i3: "https://i.postimg.cc/KcBHzy0L/af3.jpg",  
          //   i4: "https://i.postimg.cc/Y26d7zSz/af4.jpg",  
          //   i5: "https://i.postimg.cc/Wzw87TyH/af5.jpg",  
          //   i6: "https://i.postimg.cc/kX7fgR63/af7.jpg",  
          //   i7: "https://i.postimg.cc/Jz6Tg7hw/af8.jpg ", 
          // }
      ];
    
      return (
        <div>
          <div className="typewriter-text2 text-center p-md-0"><h1 className="">GALLERY</h1></div>
          {blogPosts.map((post) => (
            <GalleryCard
              key={post.title}
              {...post}
            />
          ))}
        </div>
      );
}

export default Gallery;